'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadImages = exports.loadImage = exports.deferLoadingImage = exports.CssClasses = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _themeImages = require('@shopify/theme-images');

var _functional = require('./functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var SHOPIFY_URL_REGEXP = /^\/\/cdn\.shopify\.[a-zA-Z]*\/.*$/;
var BITMAP_REGEXP = /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i;

var CssClasses = exports.CssClasses = {
  LOADER: 'lazyload',
  LOADED: 'lazyloaded'
};

var deferLoadingImage = exports.deferLoadingImage = function deferLoadingImage(imgSrc) {
  return new _promise2.default(function (resolve) {
    var img = new Image();

    img.onload = function () {
      img = null;
      resolve();
    };

    img.src = imgSrc;
  });
};

var loadImage = exports.loadImage = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(image) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var imageSrc, isShopifyImage, loadingClass, width, height, isBitmap, upscaling, imageSize;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!image.lazyloaded) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return');

          case 2:
            imageSrc = image.dataset.src;
            isShopifyImage = SHOPIFY_URL_REGEXP.test(imageSrc);
            loadingClass = options.loadingClass || CssClasses.LOADER;
            width = image.offsetWidth;
            height = image.offsetHeight;

            // Don't proceeed if the image does not have a size

            if (!(width === 0 || height === 0)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return');

          case 9:
            if (imageSrc) {
              _context.next = 11;
              break;
            }

            return _context.abrupt('return');

          case 11:

            if (isShopifyImage) {
              isBitmap = BITMAP_REGEXP.test(imageSrc);

              if (isBitmap) {
                upscaling = window.devicePixelRatio >= 2 ? '@2x' : '';
                // If there's no upscaling, set the image size to be 20% larger to get a sharper image

                if (!upscaling) {
                  width = Math.floor(width * 1.2);
                  height = Math.floor(height * 1.2);
                }

                imageSize = width + 'x' + height + '_crop_center' + upscaling;

                imageSrc = (0, _themeImages.getSizedImageUrl)(imageSrc, imageSize);
              }
            }

            _context.next = 14;
            return deferLoadingImage(imageSrc);

          case 14:

            // If it's an img tag replace the image src attribute, otherwise add it as background image
            if (image.tagName === 'IMG') {
              image.src = imageSrc;
            } else {
              image.style.backgroundImage = 'url(' + imageSrc + ')';
            }

            image.classList.add(CssClasses.LOADED);
            image.classList.remove(loadingClass);
            image.lazyloaded = true;

          case 18:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function loadImage(_x) {
    return _ref.apply(this, arguments);
  };
}();

var loadImages = exports.loadImages = function loadImages(selector, context) {
  var loadingClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CssClasses.LOADER;

  var images = (0, _functional.getElements)(selector, { context: context });

  images.forEach(function (image) {
    loadImage(image, { loadingClass: loadingClass });
  });
};